export default __webpack_public_path__ + "static/media/facebook.9a5fee20.svg";